import { AppRole } from '@/types/role';
import { api } from './client';
import { Member, MemberDetails } from '@/types/member';

export const membersApi = {
  get: async (memberId: string): Promise<Member> => {
    const { data } = await api.get(`/api/v1/members/${memberId}`);
    return data;
  },

  getMembersDetails: async (organisationId: string): Promise<MemberDetails[]> => {
    const { data } = await api.get(`/api/v1/organizations/${organisationId}/members_details`);
    return data;
  },

  getMemberRoles: async (memberId: string): Promise<AppRole[]> => {
    const { data } = await api.get(`/api/v1/members/${memberId}/role`);
    return data;
  },

  deleteMember: async (organizationId: string, memberId: string) => {
    const { data } = await api.delete(`/companies/${organizationId}/members/${memberId}`);
    return data;
  },

  updateMemberRole: async (memberId: string, roleId: string) => {
    const { data } = await api.patch(`/api/v1/members/${memberId}/role/${roleId}`);
    return data;
  }
}